<div class="dialog-container">
  <div class="dialog-header" style="direction: rtl">
    <h2 class="dialog-title">سجل التغييرات</h2>
    <button class="close-btn" (click)="close()">&#x2715;</button>
  </div>

  <div class="dialog-content">
    <div *ngFor="let item of data" class="history-item">
      <div class="history-text">
        at {{ item.date }} {{ item.userName }} has viewed customer profile
      </div>
      <div class="time">
        {{ item.time }}
      </div>
    </div>
  </div>

  <div class="dialog-actions">
    <button mat-button class="close-dialog-btn" (click)="close()">إغلاق</button>
  </div>
</div>
